/* Mikes Toolshop – Lieferdatum auf Produktkarten (Kollektionen, Suche, Startseite) */
(function () {
  if (window.mtsStartInit) return;
  window.mtsStartInit = true;

  function viennaNow() {
    var v = {};
    new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Vienna', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', weekday: 'short', hourCycle: 'h23' })
      .formatToParts(new Date()).forEach(function (p) { if (p.type !== 'literal') v[p.type] = p.value; });
    return { y: +v.year, m: +v.month, d: +v.day, h: +v.hour, min: +v.minute, wd: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].indexOf(v.weekday) };
  }
  function addWorkdays(date, n) {
    var r = new Date(date.getTime()), c = 0;
    while (c < n) { r.setUTCDate(r.getUTCDate() + 1); if (r.getUTCDay() !== 0 && r.getUTCDay() !== 6) c++; }
    return r;
  }
  function startDate(cutoff) {
    var now = viennaNow();
    var today = new Date(Date.UTC(now.y, now.m - 1, now.d));
    var p = (cutoff || '13:30').split(':');
    var before = now.h * 60 + now.min < (+p[0] || 13) * 60 + (+p[1] || 0);
    return now.wd !== 0 && now.wd !== 6 && before ? today : addWorkdays(today, 1);
  }
  function mon(d) { return new Intl.DateTimeFormat('de-DE', { timeZone: 'UTC', month: 'short' }).format(d).replace(/\.$/, '') + '.'; }
  function range(a, b) {
    if (a.getTime() === b.getTime()) return a.getUTCDate() + '. ' + mon(a);
    if (a.getUTCMonth() === b.getUTCMonth()) return a.getUTCDate() + '.–' + b.getUTCDate() + '. ' + mon(b);
    return a.getUTCDate() + '. ' + mon(a) + ' – ' + b.getUTCDate() + '. ' + mon(b);
  }
  function apply(el) {
    var m = String(el.getAttribute('data-mts-karte-tage') || '').trim().match(/^(\d+)\s*(?:[-–—]\s*(\d+))?/);
    if (!m) return;
    var a = +m[1], b = m[2] ? +m[2] : a;
    if (a < 1 || b < a || b > 3650) return;
    var s = startDate(el.getAttribute('data-mts-cutoff'));
    el.textContent = 'bei dir ' + range(addWorkdays(s, a), addWorkdays(s, b));
    el.removeAttribute('data-mts-karte-tage');
  }
  function scan(root) { (root || document).querySelectorAll('[data-mts-karte-tage]').forEach(apply); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { scan(); });
  else scan();

  // Karten, die später nachgeladen werden (Filter, Sortierung, Suche)
  new MutationObserver(function (list) {
    list.forEach(function (m) { m.addedNodes.forEach(function (n) { if (n.nodeType === 1) scan(n); }); });
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
